import { TrainingSessionStudent } from './student/training-session-student.model';

export class TrainingSessionContact {
    constructor(
        public id?: number,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public students?: TrainingSessionStudent[],
        public selected?: boolean,
        public editingMode?: string,
        public emailingMode: string = 'CONTACT_AND_STUDENTS'
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/contact/training-session-contact.model.ts